<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="97.063"
    height="107.847"
    viewBox="0 0 97.063 107.847"
  >
    <path
      id="Контур_3575"
      data-name="Контур 3575"
      d="M140.062,410.117s2.045.341,4.019.559,5.149.39,5.149.39-1.713,6.178-.718,7.588c2.3,3.26,14.86,11.309,17.74,14.54a35.466,35.466,0,0,0,4.716,4.085c1.271,1.077,5.374,1.2,6.453,2.28.721.779,1.6,3.047,1.161,3.458-.3.28-6.52.416-7.614.22a5.319,5.319,0,0,1-2.608-1.14,1.78,1.78,0,0,1-2.108.269c-2.16-1.074-1.838-3.289-3.1-5.085-.721-.718-11.279-7.642-18.082-11.47-5.836-3.285-5.577-3.237-5.849-5.784-.179-1.673.839-9.907.839-9.907Zm29.6-70.757c-2.012-.658-2.768-3.067-5.642-2.746a7.176,7.176,0,0,0-5.565,3.545,14.353,14.353,0,0,0-.284,11.381c2.211,5.514,4.975,8.881,6.4,15.074.744,3.232-.413,7.56-3.832,9.48s-9.44-6.1-25.523-5.7-23.3,8.9-28.792,11.834a23.927,23.927,0,0,0-18.271,1.693,12.6,12.6,0,0,0-6.511,11.552c0,4.143,1.321,7.616,3.646,6.745,1.442-.291,1.869-4.037,3.475-4.31,1.184-.2-.123,3.095,1.213,3.383s6.009-3.7,7.274-2.581-.973,5.5,0,6.316,5.555-.815,7.75-1.431c2.558-.715,3.525-1.144,4.223-.34-1.476,2.268-5.117,3.146-6.051,5.7s-3.653,22.127-5.154,23.925c-1.374,1.653-6.048,2.472-4.428,5.825-4.638,3.339-4.643,3.764-3.048,5.6.271.395,2.55-.156,3.677-.586,2.449-.932,9.663-5.469,10.255-6.617.542-1.034.411-3.356.643-4.523.567-2.834,3.66-15.735,4.234-16.975,1.078-2.3,9.845-7.23,12.645-7.945,3.233-.821,9.425-.93,17.339,0,5.719.673,11.311,1.448,17.787-.624,4.81-1.54,8.491-5.046,8.491-12.33,0-4.461-.327-4.811-.382-4.831h0c.031-.012.139-.1.379-.6,1.084-2.277,2.72-3.97,4.257-5.962,4.874-6.82,4.909-16.594,1.092-22.472s-4.789-7.353-4.965-11.482c-.149-3.247,1.579-5.085,4.318-4.793,1.169.125,6.327-1.077,5.991-2.605S171.669,340.016,169.658,339.36Z"
      transform="translate(-81.638 -336.584)"
      fill="#e4e5ec"
      fill-rule="evenodd"
    />
  </svg>
</template>

<script>
  export default {
    name: 'IconDelivery',
  }
</script>
